import type { DocumentRecord } from '@/types/catalog'
import type { DocumentPosition } from '@/service/api'
import { ICON_WIDTH, ICON_HEIGHT } from '@/routes/IntelligentBoard/DocumentPreviewShape'
import { GRID_LAYOUT } from '@/routes/IntelligentBoard/constants'
import { resolveBoardDocRef } from '@/routes/IntelligentBoard/utils/resolveBoardDocRef'

/**
 * Lay out the documents selected in the Data Catalog as board positions for a
 * new board, on the same 2-column grid the board canvas uses.
 *
 * Each document is resolved to its board reference via {@link resolveBoardDocRef}
 * — a processed P&ID/PFD becomes its parsed graph (graph_id + doc_type 'graph')
 * so the card renders the diagram, matching the in-board "Add files" modal and
 * the master-board sync rather than landing as a generic 'document' (FS-556).
 *
 * Pure function so the data-catalog "Open in new board" wiring is unit-testable
 * without rendering the catalog.
 */
export function buildNewBoardPositions(docs: DocumentRecord[]): DocumentPosition[] {
  return docs.map((doc, i) => {
    const col = i % GRID_LAYOUT.COLUMNS
    const row = Math.floor(i / GRID_LAYOUT.COLUMNS)
    const { document_id, doc_type } = resolveBoardDocRef(doc)
    return {
      document_id,
      x: GRID_LAYOUT.LEFT_OFFSET + col * (ICON_WIDTH + GRID_LAYOUT.MARGIN),
      y: row * (ICON_HEIGHT + GRID_LAYOUT.MARGIN),
      doc_type,
    }
  })
}
